import { gql, useQuery } from '@apollo/client';
import { EntityItem } from '../types';
import { Service } from './types';
import { DYNAMICS_FORM_FRAGMENT, SEO_FIELDS_FRAGMENT } from '../fragments';

interface QueryResult {
  mobileAppsPage: EntityItem<Service>;
}

export function useMobileApps() {
  return useQuery<QueryResult>(query);
}

const query = gql`
  ${SEO_FIELDS_FRAGMENT}
  ${DYNAMICS_FORM_FRAGMENT}
  query GetMobileApps {
    mobileAppsPage {
      data {
        id
        attributes {
          PageCopy
          MetaData {
            ...SEOFields
          }
          Banner {
            Headline
            Subhead
          }
          DynamicsForm {
            data {
              ...DynamicsFormField
            }
          }
        }
      }
    }
  }
`;
